import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import store from '@/store'

// 定义一个函数，用于获取签名
function getSign(data) {
    // 将data转换为JSON字符串，如果为空则转换为空字符串
    let _data = JSON.stringify(data) == '{}' ? '' : JSON.stringify(data)
    // 获取签名信息
    let sign = store.state.sign
    // 将data转换为MD5加密后的字符串，并加上签名信息
    let encryptedStr = CryptoJS.enc.Base64.stringify(CryptoJS.MD5(_data.replace(/\s+/g, ""))) + sign.key
    // 创建一个JSEncrypt对象
    let crypt = new JSEncrypt()
    // 设置公钥
    crypt.setPublicKey(sign.publicKey)
    // 使用公钥加密字符串
    let encrypted = crypt.encrypt(encryptedStr)

    // 返回加密后的字符串
    return encrypted || ''
}

export default getSign